import React from 'react';
import { ImageFile } from '~/data/types/images';

const yellowCircleYellow: React.FC<ImageFile> = ({
  className,
  style,
  Component = 'svg',
}) => {
  return (
    <Component
      className={className}
      style={style}
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9.5" cy="9" r="9" fill="#FFE500" />
      <g clip-path="url(#clip0_8129_176329)">
        <path
          d="M14.8454 10.0263C14.7769 10.5189 14.5531 10.9607 14.3271 11.3945C13.9457 12.1372 13.411 12.7902 12.7583 13.3101C11.987 13.9225 11.105 14.2891 10.141 14.4583C9.54346 14.5632 8.94147 14.6396 8.33117 14.6086C6.85983 14.5337 5.58977 14.0187 4.55753 12.9374C4.11956 12.471 3.74729 11.9469 3.45105 11.3796C3.27999 11.0608 3.21576 10.7273 3.15814 10.3855C3.05165 9.75316 2.98611 9.12143 3.05612 8.47514C3.14255 7.67697 3.36268 6.92889 3.76057 6.23358C4.24295 5.37454 4.90387 4.62917 5.69869 4.04783C6.49021 3.47359 7.38603 3.1794 8.3539 3.06242C9.37993 2.93017 10.4226 3.03893 11.3994 3.38005C12.3578 3.71684 13.2131 4.23072 13.7915 5.09257C14.3698 5.95443 14.7712 6.88515 14.9074 7.93854C15.0205 8.81256 14.9048 9.59897 14.8454 10.0263ZM14.2864 8.72331C14.2815 8.10976 14.2238 7.50292 14.0014 6.93237C13.8182 6.46227 13.6005 5.74609 13.2298 5.37496C12.7149 4.65791 11.998 4.22011 11.1861 3.93075C10.2605 3.59402 9.266 3.49176 8.29128 3.63306C7.29532 3.77689 6.403 4.14283 5.65264 4.82301C5.43121 5.02415 5.22027 5.23653 5.02062 5.45935C4.17275 6.40384 3.71558 7.53192 3.71607 9.38758C3.71636 10.5445 4.28653 11.5335 5.10316 12.3787C5.96998 13.2759 7.01495 13.7257 8.23711 13.8262C8.83065 13.8748 9.41573 13.8102 9.99941 13.72C11.7447 13.4503 12.9905 12.5057 13.7937 10.9372C14.2779 9.99174 14.2571 9.07079 14.2864 8.72331Z"
          fill="black"
        />
        <path
          d="M9.52074 8.60934C9.6403 8.60934 9.72999 8.60934 9.81967 8.60934C10.5756 8.61036 11.3314 8.61012 12.0873 8.6142C12.1862 8.61498 12.2846 8.62778 12.3805 8.65229C12.4301 8.6626 12.4746 8.68984 12.5064 8.72934C12.5382 8.76883 12.5554 8.8182 12.5549 8.86893C12.5599 8.91957 12.5475 8.9704 12.5198 9.0131C12.4921 9.05576 12.4507 9.08777 12.4025 9.10377C12.2772 9.14536 12.1463 9.16729 12.0144 9.16875C11.2752 9.16214 10.5361 9.1454 9.79708 9.13251C9.63928 9.12974 9.48129 9.1331 9.32374 9.12507C9.24129 9.12225 9.15972 9.10751 9.0815 9.0813C8.95791 9.03703 8.90782 8.94233 8.9171 8.80706C8.93653 8.52563 8.95008 8.24371 8.96043 7.96179C8.99405 7.04804 9.02413 6.13414 9.05867 5.22039C9.06649 5.12943 9.08092 5.03915 9.10186 4.95028C9.12464 4.82829 9.19587 4.75757 9.32359 4.75781C9.45574 4.75806 9.51637 4.8443 9.5392 4.95933C9.55781 5.04874 9.56767 5.13975 9.56864 5.23108C9.56777 6.21206 9.56471 7.19304 9.55946 8.17406C9.55873 8.30563 9.53668 8.43711 9.52074 8.60934Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_8129_176329">
          <rect
            width="12"
            height="11.625"
            fill="white"
            transform="translate(3 3)"
          />
        </clipPath>
      </defs>
    </Component>
  );
};

export default yellowCircleYellow;
